var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0571 3.14453H15.0571C15.3223 3.14453 15.5767 3.24989 15.7642 3.43742C15.9518 3.62496 16.0571 3.87931 16.0571 4.14453V6.88753C16.0571 10.8215 13.0571 14.1395 10.0571 14.1395C7.05713 14.1395 4.05713 10.8215 4.05713 6.88753V4.14453C4.05713 3.87931 4.16249 3.62496 4.35002 3.43742C4.53756 3.24989 4.79191 3.14453 5.05713 3.14453H7.05713",
    stroke: "#4F4442",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0719 14.7773C5.05692 20.2776 12.0569 23.9445 16.0569 20.2777",
    stroke: "#4F4442",
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4429 19.1328C19.8236 19.1328 20.9429 18.0135 20.9429 16.6328C20.9429 15.2521 19.8236 14.1328 18.4429 14.1328C17.0622 14.1328 15.9429 15.2521 15.9429 16.6328C15.9429 18.0135 17.0622 19.1328 18.4429 19.1328Z",
    stroke: "#4F4442",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05713 11.3711C9.01506 11.9512 11.0992 11.9512 13.0571 11.3711",
    stroke: "#4F4442",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6929 16.6328C18.6929 16.5665 18.6665 16.5029 18.6196 16.456C18.5728 16.4092 18.5092 16.3828 18.4429 16.3828",
    stroke: "#4F4442",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1929 16.6328C18.1929 16.6991 18.2192 16.7627 18.2661 16.8096C18.313 16.8565 18.3766 16.8828 18.4429 16.8828C18.5092 16.8828 18.5728 16.8565 18.6196 16.8096C18.6665 16.7627 18.6929 16.6991 18.6929 16.6328",
    stroke: "#4F4442",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4429 16.3828C18.3766 16.3828 18.313 16.4092 18.2661 16.456C18.2192 16.5029 18.1929 16.5665 18.1929 16.6328",
    stroke: "#4F4442",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctors);
export default __webpack_public_path__ + "static/media/Doctors.cee7d9ce27817d35eabc97646912fb7d.svg";
export { ForwardRef as ReactComponent };